import React from "react";
import {
	Form,
	Grid,
	Header,
	Image,
	Message,
	Segment,
	Transition,
} from "semantic-ui-react";

import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

import http from "utilities/http";

import companyLogo from "assets/images/company-logo.png";
import { useDispatch } from "react-redux";
import { userDataActions } from "reducers/userDataReducer";

function Login() {
	const dispatch = useDispatch();
	const router = useHistory();
	const submitLoginForm = async (values, handlers) => {
		try {
			const { key, password } = values;
			const response = await http({
				method: "POST",
				url: "/user/login",
				data: { key, password },
			});

			const { tokens } = response.data;
			localStorage.setItem("user", JSON.stringify({ tokens }));

			dispatch(userDataActions.addToken(tokens.accessToken));

			router.replace("/");
		} catch (error) {
			console.log({ error });
			handlers.setErrors({
				submission:
					error.response?.data?.error || "Invalid credentials.",
			});
		}
	};
	const loginForm = useFormik({
		initialValues: {
			key: "",
			password: "",
		},
		onSubmit: submitLoginForm,
	});
	return (
		<Grid
			centered
			verticalAlign="middle"
			style={{
				height: "100vh",
			}}
		>
			<Grid.Column style={{ maxWidth: "400px" }}>
				<Header textAlign="center" as="h3">
					<Image src={companyLogo} style={{ width: "185px" }} />
				</Header>
				<Form size="large" onSubmit={loginForm.handleSubmit}>
					<Segment loading={loginForm.isSubmitting}>
						<Form.Input
							fluid
							name="key"
							placeholder="User key"
							value={loginForm.values.key}
							onChange={loginForm.handleChange}
							icon="key"
						/>
						<Form.Input
							fluid
							name="password"
							type="password"
							placeholder="Password"
							value={loginForm.values.password}
							onChange={loginForm.handleChange}
							icon="lock"
						/>
						<Form.Button color="black" fluid type="submit">
							Log In
						</Form.Button>
						<Transition
							visible={loginForm.errors.submission?.length > 0}
							animation="fade"
							duration={500}
						>
							<Message
								negative
								content={loginForm.errors.submission}
							/>
						</Transition>
					</Segment>
				</Form>
			</Grid.Column>
		</Grid>
	);
}

export default Login;
